<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/grant' }"
          >授权课程</el-breadcrumb-item
        >
        <el-breadcrumb-item>课程详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main-box">
      <Card style="margin-bottom: 10px">
        <div class="panel-box">
          <h3 class="panel-title">课包基本信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="showPkg" label-width="90px">
              <el-form-item label="课包名称:">
                <p>{{ showPkg.name }}</p>
              </el-form-item>
              <el-form-item label="课包ID:">
                <p>{{ showPkg.id }}</p>
              </el-form-item>
              <br />
              <el-form-item label="级别:">
                <p>{{ showPkg.level }}</p>
              </el-form-item>
              <br />
              <el-form-item label="封面:">
                <img :src="showPkg.image" width="80px" height="80px" />
              </el-form-item>
              <br />
              <el-form-item label="周期:">
                <p>{{ showPkg.period }}课程</p>
              </el-form-item>
              <br />
              <el-form-item label="课程类型:">
                <span>特色课程</span>
              </el-form-item>
              <br />
            </el-form>
          </div>
        </div>
      </Card>
      <el-table
      stripe
      tooltip-effect="dark"
      :data="oilData"
      style="width: 100%">
      <el-table-column
      align="center"
        prop="appId"
        label="机构ID"
        width="180">
      </el-table-column>
      <el-table-column
      align="center"
        prop="name"
        label="机构名称"
        width="180">
      </el-table-column>
      <el-table-column
      align="center"
        prop="authInfo"
      label="到期时间">
      <template slot-scope="scope">
        <span v-if="scope.row.authInfo.length!=0">
          {{scope.row.authInfo[0] |formatDate2}} 至 {{scope.row.authInfo[1]|formatDate2}}
        </span>
        <span v-if="scope.row.authInfo.length==0">已取消授权</span>
        <span v-else></span>
      </template>
      </el-table-column>
      <el-table-column
      align="center"
        prop="name"
        label="操作日志">
          <template slot-scope="scope">
            <el-tooltip content="操作日志" placement="top">
              <el-button
                type="primary"
                icon="el-icon-document"
                @click="handleEdit(scope.row)"
                size="mini"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
      align="center"
        label="管理"
        width="180">
        <template slot-scope="scope">
              <span v-if="scope.row.authInfo.length!=0">
                <el-button type="primary" size="mini" @click="deleSN(scope.row.appId)">取消授权</el-button>
              </span>
              <span v-if="scope.row.authInfo.length==0"></span>
        </template>
      </el-table-column>
      </el-table>
    </div>
    <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[10,20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        ></el-pagination>
      </div>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import stUpdated from "../componentsEdu/stUpdated";

export default {
  name: "detailAuthorization",
  components: { stUpdated },
  data() {
    return {
      startData:'',
      endData:'',
      oilData: [],
      showPkg: {
        id: "",
        name: "",
        level: "",
        image: "",
        period: null,
        count: null,
        courseType:""
      },
      courseData: [],
      currId: null,
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      periodTxt: "",
      classId: null,
      type: "",
      finishData:[]
    };
  },
  created() {
    this.fetchOilData();
    if (this.$route.query.classId != undefined) {
      this.classId = `${this.$route.query.classId}`;
    }
    if (this.$route.query.type != undefined) {
      // debugger
      this.type = `${this.$route.query.type}`;
      console.log(this.$route.query.type, "8888888888");
    }
    if (this.$route.query.id != undefined) {
      this.currId = `${this.$route.query.id}`;
      let params = {
        appId: this.$API.APPID,
        id: this.currId,
        packageType: 1,
      };

      this.eduAxiosPostRequest("/edu/eduAdmin/course/extra_list", params).then((res) => {
          console.log(res,'res=======');
        if (res != null) {
            // debugger
          let m = JSON.parse(res).list[0];
          this.showPkg.id = m.id;
          this.showPkg.name = m.name;
          this.showPkg.level = m.level;
          this.showPkg.image = m.image;
          this.showPkg.packageType = m.packageType;
          
          if (m.period == 1) {
            this.showPkg.period = "日";
            this.periodTxt = "日";
          } else if (m.period == 2) {
            this.showPkg.period = "周";
            this.periodTxt = "周";
          } else if (m.period == 3) {
            this.showPkg.period = "月";
            this.periodTxt = "月";
          }
          this.showPkg.count = m.count;
          this.fetchCourseList();
        }
      });
    }
    // let params = {
    //     appId: this.$API.APPID,
    //     resourceId: Number(this.currId),
    //     resourceType: 2,
    //     pageSize: this.queryParams.pageSize,
    //     page: this.queryParams.page,
    //     operHistory: true,
    //   };
    //   this.$axios
    //     .post("edu/eduAdmin/course/fyd_get_auth_list", params)
    //     .then((response1) => {
    //       console.log(response1, "response=====");
    //       if (response1 != null) {
    //         this.oilData = response1.data.data.list;
    //         this.pageTotal = response1.data.data.pager.total;
            
    //         for(let i=0;i < this.oilData.length; ++i){
    //           if (this.oilData[i].authInfo.length != 0) {
    //             this.finishData .push(this.oilData[i]);
    //           }
    //         }
    //       }
    //     });
  },
  watch: {},
  filters:{
    formatDate2(val){
      return formatDate(val,'yyyy-MM-dd')
    }
  },
  methods: {
    deleSN(appId){
      this.currId = `${this.$route.query.id}`;
       let nowOrgan=this.oilData.filter(dtData=>{
        return appId==dtData.appId
      })
      this.$Modal.confirm({
        title: "提示",
        content:"<ul><li>是否要停止【"+nowOrgan[0].name+"】的授权</li></ul>",
        onOk: () => {
          let params = {
            appId: this.$API.APPID,
            resourceId: Number(this.currId),
            resourceType: 2,
            targetAppIds: Array(appId),
            startTime: 0,
            endTime: 0,
          };
          this.$axios
            .post("edu/eduAdmin/course/fyd_set_auth_info", params)
            .then((response) => {
              console.log(response, "response===");
              if (response.data.rc == 0) {
                this.fetchOilData()
                this.$message.success("停止授权成功");
                for(let i=0;i<this.finishData.length;++i){
                  if(appId==this.finishData[i].appId){
                    this.finishData.splice(i,1)
                    break;
                  }
                }  
              }
            });
        },
      })
    },
    handleEdit(val){
      let neeId=val.appId
      console.log(neeId,'neeId=======');
      let getCurrId=`${this.$route.query.id}`
      console.log(getCurrId,'this.getCurrId====');
      let routeUrl=this.$router.resolve({
        name:'doLogs',
        query:{
          neeId:neeId,
          id:getCurrId
        }
      })
      window.open(routeUrl.href,"_blank")
    },
    fetchOilData() {
      this.currId = `${this.$route.query.id}`;

      let params = {
        appId: this.$API.APPID,
        resourceId: Number(this.currId),
        resourceType: 2,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
        operHistory: true,
      };
      this.$axios
        .post("edu/eduAdmin/course/fyd_get_auth_list", params)
        .then((response1) => {
          console.log(response1, "response=====");
          if (response1 != null) {
            this.oilData = response1.data.data.list;
            this.pageTotal = response1.data.data.pager.total;
            for(let i=0;i<this.oilData.length;++i){
              if(this.oilData[i].authInfo.length!=0){
                this.finishData.push(this.oilData[i])
              }
            }
          }
        });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchOilData();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchOilData();
    },
    fetchCourseList() {
      let params2 = {
        appId: this.$API.APPID,
        packageId: `${this.currId}`,
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        classId: this.classId,
        // level:this.level
      };
      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/course_list",
        params2
      ).then((res2) => {
        if (res2 != null) {
          let m2 = JSON.parse(res2);
          this.courseData = m2.list;
          // this.pageTotal = m2.pager.total;
          this.step = 2;
        }
      });
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>


// WEBPACK FOOTER //
// detailOil.vue?6b252537